module.exports = __webpack_public_path__ + "media/images/help/about/heading-reason-3-3df141be7333e75743805e72138b3876.svg";